export function getTileBusinessFiles(tileImages = [], businessFiles = []) {
  return tileImages
    .map((tileImage) => {
      const { businessFileId: tileBusinessFileId } = tileImage;
      return businessFiles.find(({ id: currentId }) => currentId === tileBusinessFileId);
    })
    .filter(Boolean);
}
